import { RootState } from '../store'

export const tasksStates = (state: RootState) => state.tasks
